import RegisterPersonalDataError from './RegisterPersonalDataError';
class InvalidBirthdate extends RegisterPersonalDataError {
    constructor(birthdate, options) {
        super(`Can not register birthdate: ${birthdate}`, options);
    }
}
export default InvalidBirthdate;
